import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { styles } from './Marker.scss';

const cx = classNames.bind(styles);

export const Marker = ({ isFocused, interactive }) => {
  const classes = cx('c-map-marker', {
    'c-map-marker--focused': isFocused,
    'c-map-marker--interactive': interactive,
  });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52.999"
      height="71.879"
      viewBox="0 0 52.999 71.879"
      className={classes}>
      <defs>
        <linearGradient
          id="a"
          x1="0.055"
          y1="0.202"
          x2="0.855"
          y2="0.658"
          gradientUnits="objectBoundingBox">
          <stop offset="0" stopColor="var(--color-stop2, currentColor)" />
          <stop offset="1" stopColor="var(--color-stop1, currentColor)" />
        </linearGradient>
      </defs>
      <g transform="translate(-2154.236 -3103.633)">
        <g transform="translate(2155.736 3105.133)">
          <path
            d="M2205.735,3130.132c0,16.464-25,43.184-25,43.184s-25-26.72-25-43.184a25,25,0,0,1,50,0Z"
            transform="translate(-2155.736 -3105.132)"
            stroke="#fff"
            strokeWidth="3"
            fill="url(#a)"
          />
        </g>
        <g transform="translate(2170.509 3119.225)">
          <rect
            width="9"
            height="11"
            transform="translate(11.228 -0.092)"
            fill="#fff"
          />
          <rect
            width="9"
            height="11"
            transform="translate(11.228 13.908)"
            fill="#fff"
          />
          <rect
            width="9"
            height="11"
            transform="translate(0.228 -0.092)"
            fill="#fff"
          />
          <rect
            width="9"
            height="11"
            transform="translate(0.228 13.908)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

Marker.propTypes = {
  isFocused: PropTypes.bool,
  interactive: PropTypes.bool,
};

Marker.defaultProps = {
  isFocused: false,
  interactive: true,
};
